import styled, { keyframes } from 'styled-components';
import { Row, Col, Space } from 'antd';
import { getColor, getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var pulse = keyframes(["0%{background-color:rgba(230,230,230,0.5);}50%{background-color:rgba(220,220,220,0.8);}100%{background-color:rgba(230,230,230,0.5);}"]);
var SkeletonBlock = styled.div.withConfig({
  displayName: "assignment-list-item-skeletoncomponent__SkeletonBlock",
  componentId: "sc-a58en7-0"
})(["background-color:rgba(230,230,230,0.5);height:", ";width:", ";border-radius:4px;animation:", " 1.5s infinite ease-in-out;"], function (props) {
  return props.$height || '16px';
}, function (props) {
  return props.$width || '100%';
}, pulse);
var AssignmentCard = styled.div.withConfig({
  displayName: "assignment-list-item-skeletoncomponent__AssignmentCard",
  componentId: "sc-a58en7-1"
})(["background-color:", ";border-radius:", ";padding:", ";transition:all 0.3s;border:1px solid ", ";box-shadow:0 1px 3px 0 rgba(0,0,0,0.07);margin-bottom:", ";"], getColor('fillBgWhite'), getSize('radiusMd'), getSize('padding16'), getColor('fillIntSubActive'), getSize('padding8'));
export var AssignmentListItemSkeleton = function AssignmentListItemSkeleton() {
  return /*#__PURE__*/_jsx(AssignmentCard, {
    children: /*#__PURE__*/_jsxs(Row, {
      gutter: 16,
      align: "middle",
      children: [/*#__PURE__*/_jsx(Col, {
        span: 8,
        style: {
          borderRight: '1px solid #f0f0f0',
          paddingRight: 16
        },
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "vertical",
          size: 4,
          style: {
            width: '100%'
          },
          children: [/*#__PURE__*/_jsx(SkeletonBlock, {
            $width: "40%",
            $height: "12px"
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            $width: "80%",
            $height: "20px",
            style: {
              margin: '4px 0'
            }
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            $width: "35%",
            $height: "18px"
          })]
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 4,
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "vertical",
          size: 4,
          children: [/*#__PURE__*/_jsxs(Space, {
            size: 8,
            children: [/*#__PURE__*/_jsx(SkeletonBlock, {
              $width: "20px",
              $height: "20px",
              style: {
                borderRadius: '50%'
              }
            }), /*#__PURE__*/_jsx(SkeletonBlock, {
              $width: "70px",
              $height: "16px"
            })]
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            $width: "90px",
            $height: "16px",
            style: {
              marginTop: 4
            }
          })]
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 8,
        style: {
          borderLeft: '1px solid #f0f0f0',
          paddingLeft: 16
        },
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "vertical",
          size: 4,
          style: {
            width: '100%'
          },
          children: [/*#__PURE__*/_jsx(SkeletonBlock, {
            $width: "65%",
            $height: "16px"
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            $width: "80%",
            $height: "16px"
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            $width: "80%",
            $height: "16px"
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            $width: "85%",
            $height: "16px"
          })]
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 4,
        style: {
          textAlign: 'right'
        },
        children: /*#__PURE__*/_jsxs(Space, {
          size: 8,
          children: [/*#__PURE__*/_jsx(SkeletonBlock, {
            $width: "32px",
            $height: "32px",
            style: {
              borderRadius: '50%'
            }
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            $width: "80px",
            $height: "32px"
          })]
        })
      })]
    })
  });
};